import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useGetGroupsQuery } from '../services/api';

const useGroupOptions = (selectedCompanyId) => {
    const { id: userId, role } = useSelector((state) => state.global);
    const isSuperOrPowerAdmin = role === 'Super Admin' || role === 'Power Admin';

    const { data } = useGetGroupsQuery(selectedCompanyId, {
        skip: !selectedCompanyId,
    });

    const groupOptions = useMemo(() => {
        if (data?.groups && Array.isArray(data.groups)) {
            return data.groups
                .filter((group) => {
                    if (isSuperOrPowerAdmin) return true;
                    return group.users?.some((user) => user._id === userId);
                })
                .map((group) => ({
                    _id: group._id,
                    name: group.name,
                    deviceIds: group.devices?.map((device) => device._id) || [],
                    siteIds: group.sites?.map((site) => site._id) || [],
                    userIds: group.users?.map((user) => user._id) || [],
                }));
        }
        return [];
    }, [data, userId, isSuperOrPowerAdmin]);

    return groupOptions;
};

export default useGroupOptions;
